import { useCallback, useSyncExternalStore } from 'react'

export const useVisibilityState = () => {
  return useSyncExternalStore(
    useCallback(cb => {
      document.addEventListener('visibilitychange', cb)
      return () => {
        document.removeEventListener('visibilitychange', cb)
      }
    }, []),
    () => document.visibilityState,
    () => 'visible'
  )
}
